import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setServiceRequestFormData } from 'src/store/actions/serviceRequestForm';
import ServiceRequestFormSteps from './ServiceRequestFormSteps';
import './ServiceRequestForm.scss';

interface ServiceRequestFormProps {
  serviceRequest: any;
  from: any;
  updateServiceRequestFormVisibleStatus?: (newStatus: boolean) => void;
  propertyId?: any;
  serviceRequestSuiteInfo?: any;
  [key: string]: any;
}

const ServiceRequestForm = ({
  serviceRequest,
  from,
  ...restProps
}: ServiceRequestFormProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (serviceRequest) {
      dispatch(setServiceRequestFormData(serviceRequest));
    }
  }, [serviceRequest, dispatch]);

  return (
    <ServiceRequestFormSteps
      {...restProps}
      from={from}
      serviceRequest={serviceRequest}
    />
  );
};

export default ServiceRequestForm;
